<template>
  <div class="hello">
    <div v-if="$bus.getRole()==='merchant_empty'"><component :is="'ResetPwd'" /></div>
    <!--這個按鈕用margin-top負很大來藏起來-->
    <b-button class="loginBtn" ref="btnLogin" :v-show="isLogined==false" @click="showLoginBox">登入</b-button>
    <transition name="fade" mode="out-in" appear>
      <!-- exclude會越來越長...需要狀態傳遞跳轉組件的都要exclude否則mounted無法觸發 -->
      <keep-alive v-if="$bus.session" exclude="MerchantInfo,MerchantAdminInfo,StoreRcManage,StoreExtRvTypeManage,ResetPwd,StoreServiceExecution,ServiceExecutionList,SalesReport,ReservationChart">
        <component :is="landingComponent" />
      </keep-alive>
      <div v-else />
    </transition>
    <b-modal 
      id="loginModal"
      ref="myModal"
      v-model="showLogin" 
      centered
      hide-header
      hide-footer
      :static="true"
      @hide="closeCheck"
      @shown="setFocus"
    >
      <login
        ref="loginPopupForm"
        :loginTarget="loginTarget"
        :OKCallback="loginOK"
        :CancelCallback="loginCancel"
      />
    </b-modal>
    <b-modal 
      id="profileModal"
      ref="profileModal"
      v-model="showProfile" 
      centered
      :static="true"
      hide-header
      hide-footer
      @hide="closeProfileCheck"
    >
      <profile
        ref="profileForm"
        :profileTarget="loginTarget"
        :CancelCallback="closeProfile"
      />
    </b-modal>
  </div>
</template>

<script>

import Login from "./Login.vue"
import ResetPwd from "./ResetPwd.vue"
import Profile from "./Profile.vue"
import MerchantInfo from "./MerchantInfo"
import MerchantAdminInfo from "./MerchantAdminInfo"
import Sales from "../SalesManage/SalesView"
import SalesViewCombo from "../SalesManage/SalesViewCombo"
import Statistics from "../SalesManage/Statistics"
import Tickets from "../TicketManage/TicketManage"
import TicketProcess from "../TicketManage/TicketProcess"
import TemplateSchedule from "../ScheduleManage/TemplateSchedule"
import WaitlistAdmin from "../ReserveManage/WaitlistAdmin"
import ReservationAdmin from "../ReserveManage/ReservationAdmin"
import MakeReservation from "../ReserveManage/MakeReservation"
import UserScoreManage from "../CSManage/UserScoreManage"
import ServiceExecutionView from "../PaymentManage/ServiceExecutionView"
import ServiceExecutionList from "../PaymentManage/ServiceExecutionList"
import SalesReport from "../SalesManage/SalesReport"
import ReservationChart from "../SalesManage/ReservationChart" 
import PaymentFormAdminView from "../PaymentManage/PaymentFormAdminView"
import MerchantManage from "../StoreManage/MerchantManage"
import UnderConstruction from "./UnderConstruction"
import DevTest from "./DevTest"
//import StoreRcView from "../Common/StoreRcView"
import StoreRcManage from "../Store/StoreRcManage"
import StoreExtRvTypeManage from "../Store/StoreExtRvTypeManage"
import StoreRestTimeManage from  "../Store/StoreRestTimeManage"
import StoreAutoAcceptManage from "../Store/StoreAutoAcceptManage"
import StoreManage from "../StoreManage/StoreManage"
import StoreRestDayManage from "../StoreManage/StoreRestDayManage"
import StoreRestDayApply from "../Store/StoreRestDayApply"
import StoreServiceExecution from "../Store/StoreServiceExecution"

export default {
  name: 'LandingPage',
  data: function () {
    return {
      showLogin: false,
      showProfile: false,
    }
  },
  components: {
    // 碰到component :is=動態組入的時候要補上下面的註解否則會被lint錯誤
    /* eslint-disable vue/no-unused-components */
    Login,
    ResetPwd,
    Profile,
    MerchantInfo,
    MerchantAdminInfo,
    Sales,
    SalesViewCombo,
    Statistics,
    Tickets,
    TicketProcess,
    TemplateSchedule,
    WaitlistAdmin,
    ReservationAdmin,
    MakeReservation,
    UserScoreManage,
    ServiceExecutionView,
    ServiceExecutionList,
    PaymentFormAdminView,
    MerchantManage,
    UnderConstruction,
    DevTest,
    StoreRcManage,
    StoreExtRvTypeManage,
    StoreRestTimeManage,
    StoreAutoAcceptManage,
    StoreManage,
    StoreRestDayManage,
    StoreRestDayApply,
    StoreServiceExecution,
    // SalesReport,
    ReservationChart
  },
  props: [
    'msg',
    'loginRedirect',
    'loginTarget',
  ],
  methods: {
    showLoginBox: function () {
      this.$refs.myModal.show()
      // 詭異的異常...不知道是patch後還是改了popupform後下面的ref需在myModal show後才會有值
      setTimeout(() => {
        this.$refs.loginPopupForm.initialize()
      }, 10);
    },
    loginOK: function (data) {
      // 根據登入結果跳轉到對應的LandingPage
      this.loginRedirect(data, this)
      this.showLogin = false;
    },
    loginCancel: function () {
      this.showLogin = false;
    },
    closeCheck: function (evt) {
      if (this.showLogin) {
        evt.preventDefault()
      }
    },
    showEditProfile () {
      this.$refs.profileForm.initialize()
      this.$refs.profileModal.show()
    },
    closeProfile () {
      this.showProfile = false
    },
    closeProfileCheck (evt) {
      if (this.showProfile) {
        evt.preventDefault()
      }
    },
    setFocus: function () {
      // 設為undefined,好讓設定session為null重新叫出popup不會失效
      this.$bus.session = undefined
      this.$refs.loginPopupForm.$refs.form_input_account.focus()
    }
  },
  created: function () {
    this.showLogin = false
    let role = this.$bus.getRole()
    if (role == 'merchant' || role == 'spalogin') {
      // landing功能設定在這根本無效,mark掉
      // 有登入才判斷是總店還是分店(但實際上應該不是這樣切...)
      /*if (this.$bus.session) {
        if (this.$bus.session.isSuperManage) {
          this.$bus.landingComponent = "MerchantAdminInfo"
        }
        else {
          this.$bus.landingComponent = "MerchantInfo"
        }
      }*/
    }
    else if (role == 'merchant_empty') {
      // 是對landingComponent的例外置換,不須置換時不要清空
      // 這是重開的首頁...別設UnderConstruction,不知道要按選單的使用者會不知道怎麼辦
      this.$bus.landingComponent = "ResetPwd"
    }
    else if (role == 'admin') {
      // landing功能設定在這根本無效,mark掉
      // 是對landingComponent的例外置換,不須置換時不要清空
      // 這是重開的首頁...別設UnderConstruction,不知道要按選單的使用者會不知道怎麼辦
      /*if (this.$bus.session && this.$bus.session.role_type) {
        switch (this.$bus.session.role_type) {
          case 'admin':
          case 'sales_mgr':
          case 'sales':
            this.$bus.landingComponent = "Statistics"
            break    
          case 'support_mgr':
          case 'support':
            this.$bus.landingComponent = "Tickets"
            break
        }
      }
      else {
        this.$bus.landingComponent = "Statistics"
      }*/
    }
    else if (role == 'user') {
      this.$bus.landingComponent = "DevTest"
    }
  },
  computed: {
    landingComponent: {
      cache: false,
      get () {
        // 手機版要補上Info這個例外的判斷不然出不來,桌機版不用(應是sidebar額外觸發一次的關係)
        if (!this.$options.components[this.$bus.landingComponent] && this.$bus.landingComponent !== 'Info') {
          return "UnderConstruction"
        }
        if (this.$bus.landingComponent) {
          if (this.$bus.landingComponent == 'Info') {
            if ((this.$bus.getRole() === 'merchant' || this.$bus.getRole() == 'spalogin') && this.$bus.session) {
              //return this.$bus.session.is_super_manage?"MerchantAdminInfo":"MerchantInfo"
              return 'ServiceExecutionList'
            }
            else {
              return 'ServiceExecutionList'
            }
          }
          else {
            return this.$bus.landingComponent
          }
        }
        else {
          return ""
        }
      }
    },
    isLogined () {
      return this.$bus.session==null?false:true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.loginBtn {
  float:right;
  margin-top: -9000px;
}
</style>
